import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Alert, ErrorScreen } from 'components/common';
import { useTemplate, useUser } from 'components/hooks';
import { ROUTES } from 'consts';
import { formatProjectItems, notificationType } from 'helpers';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { WorkflowSchema } from 'schemas';
import { CircularProgress, Backdrop } from '@mui/material';
import WorkflowViewFormDumb from './WorkflowViewFormDumb';


const WorkflowViewSmart = (props) => {
  const { match: { params } } = props;
  const { workflowId } = params;
  const { parameters } = useUser();
  const projects = formatProjectItems(parameters);
  const history = useHistory();
  const [isLoadedData, setIsLoadedData] = useState(false);
  const { cleanUpMessage, error, success, putTemplate, getTemplate, data, isLoaded } = useTemplate();

  const [defaultValues, setDefaultValues] = useState({
    name: '',
    description: '',
    project: projects[0].value,
    userProject: '',
    notifications: [],
    notificationType: notificationType[0].value,
    workflowDefinition: []
  });

  useEffect(() => {
    if (!!success.put) {
      history.push(ROUTES.WORKFLOW_LIST);
    } else if (!!success.get) {
      handleData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.get, success.put]);

  useLayoutEffect(() => {
    getTemplate({ query: { templateId: workflowId } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseAlert = () => cleanUpMessage();

  const handleEdit = (data) => {
    const workflow = new WorkflowSchema();
    workflow.setValues(data);
    workflow.values.fromEdit = true;
    putTemplate({ body: workflow.getValues() });
  };

  function handleData() {
    const template = new WorkflowSchema(data[0]);
    const values = template.getValuesFormatted();
    let workflowDefinition = values.workflowDefinition ? JSON.parse(values.workflowDefinition) : [];
    if (!Array.isArray(workflowDefinition)) workflowDefinition = [];
    let notifications =  (
      data[0].notifications !== '' &&
      data[0].notifications !== '{}' &&
      data[0].notifications 
    ) ? JSON.parse(data[0].notifications) : []

    setDefaultValues({
      ...defaultValues,
      ...values,
      notifications,
      workflowDefinition
    });
    setIsLoadedData(true);
  };

  return (
    <>
      { error.get ?
        (
          <ErrorScreen />
        ): isLoaded.get ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={true}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        ): (isLoadedData && projects) ?
        (
          <WorkflowViewFormDumb
            defaultValues={defaultValues}
            handleOnSubmit={handleEdit}
            isEdit={true} />
        )
        :(
          <></>
        )
      }
      <Alert severity="error" handleClose={handleCloseAlert} open={error.put} message="common.errors.general.title" />
    </>
  );
};

export default withRequest(withRouter(WorkflowViewSmart));
